const TWITCH_EMBED_URL = 'https://embed.twitch.tv/embed/v1.js';
const TWITCH_CHAT_URL = 'https://www.twitch.tv/embed';
const TWITCH_CLIP_URL = 'https://clips.twitch.tv/embed';
const TWITCH_PLAYER_URL = 'https://player.twitch.tv/js/embed/v1.js';

const CHAT_DEFAULT_HEIGHT = 500;
const CHAT_DEFAULT_WIDTH = 350;
const MEDIA_DEFAULT_HEIGHT = 480;
const MEDIA_DEFAULT_WIDTH = 940;

export {
  TWITCH_EMBED_URL,
  TWITCH_CHAT_URL,
  TWITCH_CLIP_URL,
  TWITCH_PLAYER_URL,
  CHAT_DEFAULT_HEIGHT,
  CHAT_DEFAULT_WIDTH,
  MEDIA_DEFAULT_HEIGHT,
  MEDIA_DEFAULT_WIDTH
};
